interface Social {
  name: string;
  url: string;
  icon: string;
  alt: string;
}

export const socials: Social[] = [
  {
    name: "Instagram",
    url: "https://taap.it/NPgxK3",
    icon: "mdi:instagram",
    alt: "Instagram de Virtuosa",
  },
  {
    name: "Linkedin",
    url: "https://taap.it/3vJP20",
    icon: "mdi:linkedin",
    alt: "LinkedIn de Virtuosa",
  },
];
